import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import logo from "../assets/images/frcsit-logo.png";
import useMobile from "../hooks/useMobile";
import { useShowMenu } from "../context/ShowMenuContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { formatUrl } from "../exports/functions";
import { useSubHeadingContext } from "../context/SubHeadingContext";

const MobileNav = () => {
  const mobile = useMobile();
  const location = useLocation();
  const pathname = location.pathname;

  const isActive = (path: string) => pathname === path;
  const isOneOf = (paths: string[]) => paths.includes(pathname);

  const { companyDetailsData } = useCompanyDetailsContext();
  const { showMenu, setShowMenu } = useShowMenu();
  const [activeDropdowns, setActiveDropdowns] = useState<string[]>([]);
  const { subHeadingData } = useSubHeadingContext();

   const surgicalPaths =
    subHeadingData?.map((item) => {
      const name = item?.attributes?.Sub_Heading_Name;
      const slug = name
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
      return `/${slug}`;
    }) || [];

  const isSurgicalActive = surgicalPaths.includes(pathname);

  const toggleDropdown = (section: string) => {
    setActiveDropdowns((prev) =>
      prev.includes(section)
        ? prev.filter((item) => item !== section)
        : [...prev, section]
    );
  };

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
    setShowMenu(false);
    setActiveDropdowns([]);
  };
  return (
    <>
      <div className={`mobile-nav__wrapper ${showMenu && "expanded"}`}>
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={() => {
            setShowMenu(false);
            setActiveDropdowns([]);
          }}
        ></div>

        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={() => {
              setShowMenu(false);
              setActiveDropdowns([]);
            }}
          >
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <a href="/" aria-label="logo image">
              <img height={mobile ? "40" : "60"} src={logo} alt="logo" />
            </a>
          </div>

          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li className="dropdown megamenu">
                <Link to="/" onClick={() => linkClicker("")} className={isActive("/") ? "active-mobile-menu" : ""}>
                  Home
                </Link>
              </li>
              <li className="dropdown megamenu">
                <Link to="/about" onClick={() => linkClicker("about")} className={isActive("/about") ? "active-mobile-menu" : ""}>
                  About
                </Link>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("council");
                  }}
                  className={`
                    ${activeDropdowns.includes("council") ? "expanded" : ""}
                    ${isOneOf(["/founders", "/council-members"]) ? "active-mobile-menu" : ""} `
                  }
                >
                  The Council
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("council") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("council") ? "sub-expanded" : ""
                  }
                >
                  <li>
                    <Link
                      to="/founders"
                      onClick={() => linkClicker("founders")}
                      className={`${isActive("/founders") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Founders
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/council-members"
                      onClick={() => linkClicker("council-members")}
                      className={`${isActive("/council-members") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Council Members
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("news-events");
                  }}
                  className={`
                    ${activeDropdowns.includes("news-events") ? "expanded" : ""}
                     ${isOneOf(["/events", "/newsletters"]) ? "active-mobile-menu" : ""}`
                  }
                >
                  News & Events{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("news-events") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("news-events")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li>
                    <Link
                      to="/newsletters"
                      onClick={() => linkClicker("newsletters")}
                      className={`${isActive("/newsletters") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Newsletters
                    </Link>
                  </li>
                  <li>
                    <Link to="/events" onClick={() => linkClicker("events")} className={`${isActive("/events") ? "active-mobile-menu" : ""} ps-3`}>
                      Events
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("members-area");
                  }}
                  className={`
                    ${activeDropdowns.includes("members-area") ? "expanded" : ""}
                    ${isOneOf(["/benefits-of-a-member", "/become-a-member"]) ? "active-mobile-menu" : ""}
                    `
                  }
                >
                  Members Area{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("members-area") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("members-area")
                      ? "sub-expanded"
                      : ""
                  }
                > 
                  <li>
                    <Link
                      to="/benefits-of-a-member"
                      onClick={() => linkClicker("benefits-of-a-member")}
                      className={`${isActive("/benefits-of-a-member") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Benefits of a Member
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/become-a-member"
                      onClick={() => linkClicker("become-a-member")}
                      className={`${isActive("/become-a-member") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Become a Member
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/list-of-all-member"
                      onClick={() => linkClicker("list-of-all-member")}
                    >
                      List of All Members
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("our-training");
                  }}
                  className={
                    `${activeDropdowns.includes("our-training") ? "expanded" : ""}
                    ${isOneOf(["/fellowship", "/observership"]) ? "active-mobile-menu" : ""}
                    `
                  }
                >
                  Our Training
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("our-training") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("our-training")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li>
                    <Link
                      to="/fellowship"
                      onClick={() => linkClicker("fellowship")}
                      className={`${isActive("/fellowship") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Fellowship
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/observership"
                      onClick={() => linkClicker("observership")}
                      className={`${isActive("/observership") ? "active-mobile-menu" : ""} ps-3`}
                    >
                      Observership
                    </Link>
                  </li>
                </ul>
              </li>
              {/* <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("surgical-domains");
                  }}
                  className={
                    activeDropdowns.includes("surgical-domains")
                      ? "expanded"
                      : ""
                  }
                >
                  Surgical Domains{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("surgical-domains")
                        ? "expanded"
                        : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("surgical-domains")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("overview");
                      }}
                      className={
                        activeDropdowns.includes("overview") ? "expanded" : ""
                      }
                    >
                      Overview
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("overview") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("overview")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/types-of-facial-plastic-surgery"
                          onClick={() =>
                            linkClicker("types-of-facial-plastic-surgery")
                          }
                        >
                          Types of Facial Plastic Surgery
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/who-is-a-facial-plastic-surgeon"
                          onClick={() =>
                            linkClicker("who-is-a-facial-plastic-surgeon")
                          }
                        >
                          Who is a Facial Plastic Surgeon
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("nose");
                      }}
                      className={
                        activeDropdowns.includes("nose") ? "expanded" : ""
                      }
                    >
                      Nose{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("nose") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("nose") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/rhinoplasty"
                          onClick={() => linkClicker("rhinoplasty")}
                        >
                          Rhinoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("eyelids");
                      }}
                      className={
                        activeDropdowns.includes("eyelids") ? "expanded" : ""
                      }
                    >
                      Eyelids{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("eyelids") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("eyelids")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/lower-blepharoplasty"
                          onClick={() => linkClicker("lower-blepharoplasty")}
                        >
                          Lower Blepharoplasty
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/upper-blepharoplasty"
                          onClick={() => linkClicker("upper-blepharoplasty")}
                        >
                          Upper Blepharoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("lifts");
                      }}
                      className={
                        activeDropdowns.includes("lifts") ? "expanded" : ""
                      }
                    >
                      Lifts{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("lifts") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("lifts") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/face-lift"
                          onClick={() => linkClicker("face-lift")}
                        >
                          Face Lift
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/fore-head-lift"
                          onClick={() => linkClicker("fore-head-lift")}
                        >
                          ForeHead Lift
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("chin-ears");
                      }}
                      className={
                        activeDropdowns.includes("chin-ears") ? "expanded" : ""
                      }
                    >
                      Chin & Ears{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("chin-ears")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("chin-ears")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/mentoplasty"
                          onClick={() => linkClicker("mentoplasty")}
                        >
                          Mentoplasty
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/otoplasty"
                          onClick={() => linkClicker("otoplasty")}
                        >
                          Otoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("skin");
                      }}
                      className={
                        activeDropdowns.includes("skin") ? "expanded" : ""
                      }
                    >
                      Skin
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("skin") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("skin") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/scar-revision"
                          onClick={() => linkClicker("scar-revision")}
                        >
                          Scar Revision
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/skin-cancer"
                          onClick={() => linkClicker("skin-cancer")}
                        >
                          Skin Cancer
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/skin-peels"
                          onClick={() => linkClicker("skin-peels")}
                        >
                          Skin Peels
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("injectables");
                      }}
                      className={
                        activeDropdowns.includes("injectables")
                          ? "expanded"
                          : ""
                      }
                    >
                      Injectables
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("injectables")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("injectables")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/botulinum-toxin"
                          onClick={() => linkClicker("botulinum-toxin")}
                        >
                          Botulinum Toxin
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown("lipoplasty");
                      }}
                      className={
                        activeDropdowns.includes("lipoplasty") ? "expanded" : ""
                      }
                    >
                      Lipoplasty{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("lipoplasty")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("lipoplasty")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/fat-grafting"
                          onClick={() => linkClicker("fat-grafting")}
                        >
                          Fat Grafting
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li> */}
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("surgical-domains");
                  }}
                  className={`
                    ${activeDropdowns.includes("surgical-domains")
                      ? "expanded"
                      : ""}
                    ${isSurgicalActive ? 'active-mobile-menu' : ''}
                      `
                  }
                >
                  Surgical Domains{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("surgical-domains")
                        ? "expanded"
                        : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>

                <ul
                  className={
                    activeDropdowns.includes("surgical-domains")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  {subHeadingData?.map((item) => {
                    const name = item.attributes.Sub_Heading_Name;
                    const slug = name
                      .toLowerCase()
                      .replace(/&/g, "and")
                      .replace(/[^\w\s-]/g, "")
                      .trim()
                      .replace(/\s+/g, "-");

                    return (
                      <li key={item.id}>
                        <Link
                          to={`/${slug}`}
                          onClick={() => linkClicker(slug)}
                           className={
                              `${isActive(`/${slug}`) ? "active-mobile-menu" : ""} ps-3`
                            }
                          style={{ lineHeight: "18px" }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span>{name}</span>
                            <span style={{ fontSize: "10px" }}>
                              {item.attributes.Doctor_Name}
                            </span>
                          </div>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
              <li>
                <Link to="/gallery" onClick={() => linkClicker("gallery")} className={isActive("/gallery") ? "active-mobile-menu" : ""}>
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/archive" onClick={() => linkClicker("archive")} className={isActive("/archive") ? "active-mobile-menu" : ""}>
                  Archive
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => linkClicker("contact")} className={isActive("/contact") ? "active-mobile-menu" : ""}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-phone-alt"></i>
              <a
                href={`tel:${companyDetailsData[0]?.attributes?.Phone_Number}`}
              >
                {companyDetailsData[0]?.attributes?.Phone_Number}
              </a>
            </li>
            <li>
              <i className="fa fa-envelope"></i>
              <a href={`mailto:${companyDetailsData[0]?.attributes?.Email}`}>
                {companyDetailsData[0]?.attributes?.Email}
              </a>
            </li>
          </ul>
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              {companyDetailsData[0]?.attributes?.TwitterX_Link !== null && (
                <a
                  href={formatUrl(
                    companyDetailsData[0]?.attributes?.TwitterX_Link
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-x"
                >
                  <span></span>
                </a>
              )}
              {companyDetailsData[0]?.attributes?.Facebook_Link !== null && (
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.Facebook_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="fab fa-facebook-square"
              >
                <span></span>
              </a>
              )}
              {companyDetailsData[0]?.attributes?.Instagram_Link !== null && (
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.Instagram_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="fab fa-instagram"
              >
                <span></span>
              </a>
              )}
              {companyDetailsData[0]?.attributes?.LinkedIn_Link !== null && (
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.LinkedIn_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="icon-linkedin"
              >
                <span></span>
              </a>
              )}
              {companyDetailsData[0]?.attributes?.Tiktok_Link !== null && (
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.Tiktok_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="icon-tiktok"
              >
                <span></span>
              </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="search-popup">
        <div className="search-popup__overlay search-toggler"></div>

        <div className="search-popup__content">
          <form action="#">
            <label className="sr-only">search here</label>
            <input type="text" id="search" placeholder="Search Here..." />
            <button
              type="submit"
              aria-label="search submit"
              className="thm-btn"
            >
              <i className="icon-magnifying-glass"></i>
            </button>
          </form>
        </div>
      </div> */}
    </>
  );
};

export default MobileNav;
